/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2021 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
/* global window */

import { withMemoryRouter } from './services/ReactRouterAPI';
import SophiaProviderImpl from './services/SophiaProviderImpl';
import Asset2APIImpl from './services/Asset2APIImpl';
import TargetAPIImpl from './services/TargetAPIImpl';

// Get providers from the global environment rather than from an import
// That way we don't have a compile-time dependency and we avoid bi-directional
// dependencies between dc-core and dc-extras
const core = window.adobe_dc_sdk.appLauncher.coreFunction();

const router = core.router;

// supply the implementation part of the router that relies on react-router.
router.withMemoryRouter = withMemoryRouter;

// now that extras are loaded, fill in the implementations of these providers
window.adobe_dc_sdk.SophiaImplementation = SophiaProviderImpl;
window.adobe_dc_sdk.Asset2Implementation = Asset2APIImpl;
window.adobe_dc_sdk.TargetImplementation = TargetAPIImpl;
